import { Study } from "../../../../shared/entities/scripts/study";
import { GetDateFromString } from "../../../../shared/scripts/date-functions";
import { CreateSeries_ActualDays } from "../../../../shared/scripts/graphing/graphing-functions";
import { IGraphDataPoint } from "../../../../shared/scripts/graphing/graphing.entities";
import { PadNumber } from "../../../../shared/scripts/number-functions";
import { FormatStringColumnByLength } from "../../../../shared/scripts/table-functions";

export class PrescreeningEntry {
    Type: number; //0: summary, 1: weekly, 2: site with consent, no prescreening
    PrimeId: number;
    SiteNumber: number;
    DateWeekStart: string;
    DateActivation: string = "";
    DateFirstEnrollment: string = "";
    DateLatestEnrollment: string = "";
    DateLatestPrescreening: string = "";
    Counts: number[] = [-1, -1, -1, -1, -1, -1, -1, -1]; //0: Total Pre-Screened, 1: No Phone, 2: PassScreen, 3: In-Person, 4: Randomized, 5: Screened Post-Consent, 6: Screen-Fails
    AgesPrescreen: number[] = [-1, -1, -1, -1]; //0: 18-30, 1: 31-50, 2: 51-70, 3: 71+

    //0: White, 1: Black, 2: AIAN, 3: Asian, 4: NHOPI, 5: MENA, 6: Two or More, 7: Unknown, 8: Non-White
    RacesPrescreen: number[] = [-1, -1, -1, -1, -1, -1, -1, -1, -1];
    RacesConsented: number[] = [-1, -1, -1, -1, -1, -1, -1, -1, -1];
    RacesScreenFail: number[] = [-1, -1, -1, -1, -1, -1, -1, -1, -1];
    RacesRandomized: number[] = [-1, -1, -1, -1, -1, -1, -1, -1, -1];

    //0: Not Hispanic, 1: Hispanic, 2: Unknown, 3: Non-White OR Hispanic (a hybrid with Race)
    EthnicitiesPrescreen: number[] = [-1, -1, -1, -1];
    EthnicitiesConsented: number[] = [-1, -1, -1, -1];
    EthnicitiesScreenFail: number[] = [-1, -1, -1, -1];
    EthnicitiesRandomized: number[] = [-1, -1, -1, -1];

    //0: Prescreen, 1: Consented, 2: ScreenFail, 3: Randomized
    PercentNonWhite: number[] = [-1, -1, -1, -1];
    PercentHispanic: number[] = [-1, -1, -1, -1];
    PercentNonWhiteOrHispanic: number[] = [-1, -1, -1, -1];

    Exclusions: number[] = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]; //0: Any, 1: Active COVID, 2: DrugUse, 3: ContraMedicine, 4: Pregnant, 5: Allergy, 6: Immunocomprised, 7: Recent Paxlovid, 8: No Symptom Cluster, 9: MedicalCondition, 10: Invest Decision, 11: Patient Reason, 12: Recent Trial
    NoInPerson: number[] = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1]; //0: Declined, 1: Risks, 2: Doctor Declined, 3: Family Declined, 4: TooBusy, 5: Compensation, 6: Travel, 7: Privacy, 8: Trust, 9: Other, 10: Unknown

    SiteName: string;
    PrimeContract: string;
    SiteNumberDisplay: string;
    SiteNameDisplay: string;

    WeekStartDate: Date;
    ActivationDate: Date;
    FirstEnrollmentDate: Date;
    LatestEnrollmentDate: Date;

    WeekStartTimestamp: number;
    ActivationTimestamp: number;
    FirstEnrollmentTimestamp: number;
    LatestEnrollmentTimestamp: number;

    SiteHash: string;

    WeeklyEntries: PrescreeningEntry[];
    MaxTimestamp: number;
    ChartSeriesName: string;
    ChartSeriesData: any[];
    ChartSeriesIndex: number;

    initialize(): void {

        this.PrimeContract = Study.GetStudyName(this.PrimeId);
        delete this.PrimeId;

        this.SiteHash = this.PrimeContract + "-" + this.SiteNumber;
        this.ChartSeriesName = this.SiteName + " (" + this.PrimeContract + ")";

        this.WeekStartDate = GetDateFromString(this.DateWeekStart, "slash-month-day-year");
        this.ActivationDate = GetDateFromString(this.DateActivation, "slash-month-day-year");
        this.FirstEnrollmentDate = GetDateFromString(this.DateFirstEnrollment, "slash-month-day-year");
        this.LatestEnrollmentDate = GetDateFromString(this.DateLatestEnrollment, "slash-month-day-year");

        this.MaxTimestamp = 0;

        if (this.WeekStartDate != undefined) {
            this.WeekStartTimestamp = this.WeekStartDate.getTime();
            if (this.WeekStartTimestamp > this.MaxTimestamp) this.MaxTimestamp = this.WeekStartTimestamp;
        }
        if (this.ActivationDate != undefined) {
            this.ActivationTimestamp = this.ActivationDate.getTime();
            if (this.ActivationTimestamp > this.MaxTimestamp) this.MaxTimestamp = this.ActivationTimestamp;
        }
        if (this.FirstEnrollmentDate != undefined) {
            this.FirstEnrollmentTimestamp = this.FirstEnrollmentDate.getTime();
            if (this.FirstEnrollmentTimestamp > this.MaxTimestamp) this.MaxTimestamp = this.FirstEnrollmentTimestamp;
        }
        if (this.LatestEnrollmentDate != undefined) this.LatestEnrollmentTimestamp = this.LatestEnrollmentDate.getTime();

        this.SiteNumberDisplay = PadNumber(this.SiteNumber + "", 3);
        this.SiteNameDisplay = FormatStringColumnByLength(this.SiteName, 4);

        this.computePercentages();

        //if (this.SiteNumber == 131 && this.Type == 0) console.log(this);

        //console.log(this);
    }

    createChartSeries(): void {

        this.ChartSeriesData = CreateSeries_ActualDays(this.WeeklyEntries.map((entry: PrescreeningEntry) => entry.createGraphDataPoint()), true);
        this.WeeklyEntries.forEach((entry: PrescreeningEntry) => {
            if (entry.WeekStartDate.getTime() > this.MaxTimestamp) { this.MaxTimestamp = entry.WeekStartDate.getTime(); }
        });
    }

    createGraphDataPoint(): PrescreeningGraphDataPoint {
        return new PrescreeningGraphDataPoint(this.SiteName, this.PrimeContract, this.SiteHash, this.Counts[0], this.WeekStartDate);
    }

    computePercentages(): void {
        this.PercentNonWhite[0] = this.calculatePercent(this.RacesPrescreen[8], this.Counts[0]);
        this.PercentNonWhite[1] = this.calculatePercent(this.RacesConsented[8], this.Counts[5]);
        this.PercentNonWhite[2] = this.calculatePercent(this.RacesScreenFail[8], this.Counts[6]);
        this.PercentNonWhite[3] = this.calculatePercent(this.RacesRandomized[8], this.Counts[4]);

        this.PercentHispanic[0] = this.calculatePercent(this.EthnicitiesPrescreen[1], this.Counts[0]);
        this.PercentHispanic[1] = this.calculatePercent(this.EthnicitiesConsented[1], this.Counts[5]);
        this.PercentHispanic[2] = this.calculatePercent(this.EthnicitiesScreenFail[1], this.Counts[6]);
        this.PercentHispanic[3] = this.calculatePercent(this.EthnicitiesRandomized[1], this.Counts[4]);

        this.PercentNonWhiteOrHispanic[0] = this.calculatePercent(this.EthnicitiesPrescreen[3], this.Counts[0]);
        this.PercentNonWhiteOrHispanic[1] = this.calculatePercent(this.EthnicitiesConsented[3], this.Counts[5]);
        this.PercentNonWhiteOrHispanic[2] = this.calculatePercent(this.EthnicitiesScreenFail[3], this.Counts[6]);
        this.PercentNonWhiteOrHispanic[3] = this.calculatePercent(this.EthnicitiesRandomized[3], this.Counts[4]);

    }

    addPrescreeningEntry(entry: PrescreeningEntry): void {

        let arrays: string[] = ["Counts", "AgesPrescreen", "RacesPrescreen", "RacesConsented", "RacesScreenFail", "RacesRandomized", "EthnicitiesPrescreen", "EthnicitiesConsented", "EthnicitiesScreenFail", "EthnicitiesRandomized", "Exclusions", "NoInPerson" ];
        arrays.forEach((array: string) => this[array] = this.addArrayValues(this[array], entry[array]));

    }

    private calculatePercent(numerator: number, denominator: number): number {
        if (numerator == -1 || denominator <= 0) return -1;
        else return numerator / denominator;
    }

    private addArrayValues(array1: number[], array2: number[]): number[] {
        for (let i = 0; i < array1.length; ++i) {
            if (array2[i] >= 0) {
                if (array1[i] == -1) { array1[i] = array2[i]; }
                else { array1[i] += array2[i]; }
            }
        }

        return array1;
    }

    private getDateValue(date: Date): number {
        if (date == undefined) return undefined;
        else return date.getTime();
    }
}

export class PrescreeningGraphDataPoint implements IGraphDataPoint {
    Count: number;
    Timestamp: number;

    SiteHash: string;
    PrimeContract: string;
    SiteName: string;


    constructor(siteName: string, primeContract: string, siteHash: string, count: number, date: Date) {
        this.SiteName = siteName;
        this.PrimeContract = primeContract;
        this.SiteHash = siteHash;
        this.Count = count;
        this.Timestamp = date.getTime();
    }

    getTimestamp(): number { return this.Timestamp; }
    getCount(): number { return this.Count; }
}
